<template>
  <Loader :value="promise" theme="default" class="task-reference-activity">
    <Activity v-if="item" :item="item" />
  </Loader>
</template>

<script>
import Api from '@/api/Activity'
import Activity from '@/components/Lead/Themes/Compact.vue'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceActivity' }).then(item => (this.item = item))
    },
  },
  components: {
    Activity,
  },
}
</script>

<style lang="scss">
.task-reference-activity {
  flex-grow: initial;
  padding-right: 2.5rem;

  [data-part='action'] {
    display: none;
  }
}
</style>
